import instance from "@/services/api";

export const bufferParamsAPI = {
  async getList(params) {
    return await instance()
      .get("/project_list/floor_buffer/read/", { params })
      .then((res) => res?.data);
  },
  async getFloors(params) {
    return await instance()
      .get(`/project_list/common/entrance_floors/read/`, { params })
      .then((res) => res?.data);
  },
  async deleteParam(body, params) {
    return await instance()
      .post(`/project_list/floor_buffer/delete/`, body, { params })
      .then((res) => res?.data);
  },
  async deleteRevitParam(body, params) {
    return await instance()
      .post(`/project_list/floor_buffer/revit_data/delete/`, body, { params })
      .then((res) => res?.data);
  },
  async updateParam(body, params) {
    return await instance()
      .post(`/project_list/floor_buffer/set_param_type/`, body, { params })
      .then((res) => res?.data);
  },
};
